import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const STATUS_STYLES = {
  draft: 'bg-slate-100 text-slate-700',
  pending_approval: 'bg-amber-100 text-amber-800',
  approved: 'bg-emerald-100 text-emerald-700',
  rejected: 'bg-red-100 text-red-700',
};

export const STATUS_LABELS = {
  draft: 'Draft', pending_approval: 'Pending Approval', approved: 'Approved', rejected: 'Rejected',
};

export const userHasRole = (user, roles) => {
  const mine = user?.roles || (user?.role ? [user.role] : []);
  return roles.some(r => mine.includes(r));
};

export const apiError = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(', ');
  return d || fallback;
};

export const isApprover = (user) => userHasRole(user, ['admin', 'manager']);

export const ApprovalBadge = ({ status, testId }) => {
  const s = status || 'approved';
  return <Badge data-testid={testId} className={`${STATUS_STYLES[s] || STATUS_STYLES.draft} font-medium`}>{STATUS_LABELS[s] || s}</Badge>;
};

export const StatusTabs = ({ value, onChange, counts = {}, prefix }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${prefix}-status-tabs`}>
    {['all', 'draft', 'pending_approval', 'approved', 'rejected'].map(s => (
      <button
        key={s}
        type="button"
        data-testid={`${prefix}-tab-${s}`}
        onClick={() => onChange(s)}
        className={`px-3 py-1.5 rounded-full text-sm border transition-colors duration-150 ${
          value === s ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'
        }`}
      >
        {s === 'all' ? 'All' : STATUS_LABELS[s]}
        {counts[s] !== undefined && <span className="ml-1.5 opacity-70">{counts[s]}</span>}
      </button>
    ))}
  </div>
);

export const RejectDialog = ({ open, onClose, onConfirm, title, prefix }) => {
  const [reason, setReason] = useState('');
  const submit = async () => { await onConfirm(reason.trim()); setReason(''); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setReason(''); onClose(); } }}>
      <DialogContent className="max-w-md" data-testid={`${prefix}-reject-dialog`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>The sales person will see this reason and can edit and resubmit.</DialogDescription>
        </DialogHeader>
        <Textarea data-testid={`${prefix}-reject-reason`} value={reason} onChange={e => setReason(e.target.value)} placeholder="Reason for rejection" rows={4} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid={`${prefix}-reject-confirm`} disabled={!reason.trim()} onClick={submit} className="bg-red-600 hover:bg-red-700 text-white">Reject</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
